import React from "react";

//Import Breadcrumb
import { Checkbox, FormControlLabel, FormHelperText, Grid, InputAdornment, Stack } from "@mui/material";
import { connect } from 'react-redux';
import CustomProductAutocomplete from "../../../components/Form/CustomProductAutocomplete";
import CustomButton from "../../../components/Form/CustomButton";
import CustomSelect from "../../../components/Form/CustomSelect";
import CustomTextField from "../../../components/Form/CustomTextField";
import Helpers from "../../../helpers/helpers";
import "../../Orders/order.css";

const ConfigProductSpecFiled = ({ setOpenServicesField, tempServices, error, setTempServices, tabsDataArry, edit, setEditId, handleSaveEdit, id, handleAddServices, configurationDetails, tabValue, productListing, setError, allowMultipleSelect }) => {

    const handleInputChange = (e, value, id, reason) => {
        if (id) {
            const existingProduct = productListing?.find(product => product.name === value);

            if (existingProduct) {
                setTempServices((prevValues) => ({
                    ...prevValues,
                    display_name: value || "",
                    product_id: existingProduct.id,
                    sku: existingProduct.sku,
                    quantity: existingProduct.quantity || '0',
                }));
            } else {
                setTempServices((prevValues) => ({
                    ...prevValues,
                    display_name: value || "",
                    product_id: "",
                }))
            }
        } else {
            const existingProduct = productListing?.find(product => product.name === value);
            if (existingProduct) {
                setTempServices((prevValues) => ({
                    ...prevValues,
                    display_name: value || "",
                    product_id: existingProduct.id,
                    sku: existingProduct.sku,
                    quantity: existingProduct.quantity || '0',
                }));
            } else {
                setTempServices((prevValues) => ({
                    ...prevValues,
                    display_name: value || "",
                    product_id: "",
                    sku: value ? (value).replace(/ /g, "-") : ""
                }))
            }
        }

    }

    const handleChange = (e, value) => {
        if (value?.id) {
            setTempServices((prevValues) => ({
                ...prevValues,
                display_name: value?.name || "",
                product_id: value?.id || "",
                sku: value?.sku || "",
                quantity: value?.quantity || null,

            }))
        }
    }

    return (
        <div className="pt-4">
            <Grid container sx={{ border: '1px solid #e0e0e0', borderRadius: "8px", backgroundColor: "#fafafa" }} p={2} pt={0}>
                <Grid item xs={12} pb={3}>
                    <Stack direction={{ xs: "column-reverse", sm: "row" }} pt={2} gap={1} justifyContent={"space-between"}>
                        <Stack direction={"row"} gap={1} alignItems={"center"}>
                            <div style={{ border: '1px solid #D0D0D0', borderRadius: "5px", height: "42px", width: "42px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <i className={tabsDataArry?.icon} style={{ fontSize: "24px" }}></i>
                            </div>
                            <div>
                                <span className="setting-form-section-header font-size-14" >New option for <span style={{ textTransform: 'lowercase' }}>{Helpers?.capitalizeWords(tabsDataArry?.name)}</span></span>
                            </div>
                        </Stack>
                        <div className="d-flex justify-content-end">
                            <CustomButton
                                borderStyle={"1px solid #999999"}
                                title={<span><i className="ri-close-fill me-2"></i>Cancel</span>}
                                press={() => edit ?
                                    (setEditId(""), setError(false), setTempServices([])) : (setOpenServicesField(false), setError(false), setTempServices([]))
                                }
                                height={26}
                                backgroundColor={'transparent'}
                                textColor={'#999999'}
                            />
                        </div>
                    </Stack>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={12} style={{ width: "100px" }}>
                        <CustomSelect
                            title={'Type'}
                            values={tempServices?.configuration_item_id || '-1'}
                            valueName={"id"}
                            labelName={"name"}
                            placeholder={""}
                            onChange={(e) => setTempServices((prevValues) => ({
                                ...prevValues,
                                configuration_item_id: e
                            }))}

                            error={error && !tempServices?.configuration_item_id && "The product spec type is required."}
                            data={configurationDetails?.data?.items}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormControlLabel
                            sx={{ marginBottom: "0px" }}
                            control={
                                <Checkbox checked={tempServices?.deduct_quantity == 1 ? true : false}
                                    sx={{
                                        '&.Mui-checked': {
                                            color: "var(--bs-theme-color)",
                                        },
                                        color: '#52525280'
                                    }}
                                    onChange={(event) => {
                                        setTempServices((prevValues) => ({
                                            ...prevValues,
                                            deduct_quantity: event.target.checked ? 1 : 0,
                                            quantity: event.target.checked ? tempServices?.quantity : "",
                                            display_name: "",
                                            sku: event.target.checked ? tempServices?.sku : "",
                                        }));
                                    }}

                                    value={tempServices?.deduct_quantity == 1 ? true : false} />
                            }
                            label={<span style={{ fontFamily: 'Manrope', fontSize: 14 }}>Deduct inventory</span>}
                        />
                    </Grid>

                    {
                        tempServices?.deduct_quantity == 1 ?
                            <Grid item xs={12} >
                                <CustomProductAutocomplete
                                    labelName={"name"}
                                    valueName={"id"}
                                    title={'Display Name'}
                                    values={tempServices?.display_name}
                                    placeholder={""}
                                    onChange={(e, value) => handleChange(e, value)}
                                    onInputChange={(e, value, reason) => handleInputChange(e, value, reason)}
                                    data={productListing}
                                    error={error && !tempServices?.display_name && "The product display name is required."}
                                />
                            </Grid>
                            :
                            <Grid item xs={12} >
                                <CustomTextField
                                    labelName={"name"}
                                    valueName={"id"}
                                    title={'Display Name'}
                                    values={tempServices?.display_name}
                                    placeholder={""}
                                    onChange={(e) => setTempServices((prevValues) => ({
                                        ...prevValues,
                                        display_name: e
                                    }))}
                                    // onInputChange={(e, value) => handleInputChange(e, value)}
                                    // data={productListing}
                                    error={error && !tempServices?.display_name && "The product display name is required."}
                                />
                            </Grid>
                    }
                    {(tempServices?.deduct_quantity) ?
                        <>
                            <Grid item xs={12} sm={6}>
                                <CustomTextField
                                    title={'SKU'}
                                    disabled={true}
                                    values={tempServices?.sku}
                                    error={error && error?.[`variants.${tabValue}.sku`]}
                                    onChange={(e) => setTempServices((prevValues) => ({
                                        ...prevValues,
                                        sku: e
                                    }))}
                                    placeholder="SKU"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <CustomTextField
                                    title={'Quantity'}
                                    type="number"
                                    disabled={tempServices?.product_id ? true : false}
                                    values={tempServices?.quantity || ""}
                                    onChange={(e) => {
                                        setTempServices((prevValues) => ({
                                            ...prevValues,
                                            quantity: e
                                        }))
                                    }}

                                    placeholder="0"
                                />
                            </Grid>
                        </>
                        :
                        ""
                    }
                    <Grid item xs={12}>
                        <CustomTextField
                            title={'Additional information'}
                            values={tempServices?.additional_info}
                            onChange={(e) => setTempServices((prevValues) => ({
                                ...prevValues,
                                additional_info: e
                            }))}
                            placeholder=""
                        />
                        <FormHelperText>The specific details that highlighting options, which appears under the display name in the details page.</FormHelperText>
                    </Grid>
                    <Grid item xs={12} sm={allowMultipleSelect?.find((y, idx) => y == tabsDataArry?.id) ? 6 : 12}>
                        <CustomTextField
                            title={'Additional price (if applicable)'}
                            values={tempServices?.add_price}
                            onChange={(e) => setTempServices((prevValues) => ({
                                ...prevValues,
                                add_price: e
                            }))}
                            InputProps={{
                                startAdornment: <InputAdornment position="start" className='auth-icon'>S$</InputAdornment>,
                            }}
                            type="number"
                            placeholder="0.00"
                        />
                        <FormHelperText>Specify any additional cost for selecting this option.</FormHelperText>
                    </Grid>
                    {allowMultipleSelect?.find((y, idx) => y == tabsDataArry?.id) && <Grid item xs={12} sm={6}>
                        <CustomTextField
                            title={'Purchase Limit'}
                            type="number"
                            values={tempServices?.purchase_limit || ""}
                            error={error && tempServices?.purchase_limit < 1 ? "The purchase limit field must be at least 1." : error && !tempServices?.purchase_limit && "The purchase limit field is required."}
                            onChange={(e) => {
                                setTempServices((prevValues) => ({
                                    ...prevValues,
                                    purchase_limit: e
                                }))
                            }}

                            placeholder="0"
                        />
                    </Grid>}
                    <Grid item xs={12} sm={6}>
                        <CustomTextField
                            title={"Group Name"}
                            values={tempServices?.group_name}
                            subtitle={"To group related specifications. Users can select only one option from each group."}
                            onChange={(e) => {
                                setTempServices((prevValues) => ({
                                    ...prevValues,
                                    group_name: e
                                }))
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <CustomTextField
                            title={"Sort Order"}
                            values={tempServices?.sort_order}
                            error={error && error?.sort_order}
                            onChange={(e) => {
                                setTempServices((prevValues) => ({
                                    ...prevValues,
                                    sort_order: e
                                }))
                            }}
                            subtitle={"Determines the display sequence. Items are shown in ascending order (lowest value first)."}
                            placeholder={"e.g. 0"}
                            type="number"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormControlLabel
                            sx={{ marginBottom: "0px" }}
                            control={
                                <Checkbox checked={tempServices?.is_default === 1 ? true : false}
                                    sx={{
                                        '&.Mui-checked': {
                                            color: "var(--bs-theme-color)",
                                        },
                                        color: '#52525280'
                                    }}
                                    onChange={(event) => setTempServices((prevValues) => ({
                                        ...prevValues,
                                        is_default: event.target.checked ? 1 : 0
                                    }))}
                                    value={tempServices?.is_default === 1 ? true : false} />
                            }
                            label={<span style={{ fontFamily: 'Manrope', fontSize: 14 }}>Set as default selected option</span>}
                        />
                    </Grid>
                </Grid>

            </Grid>
            <div className="pt-3">
                <CustomButton
                    title={'Save'}
                    press={() => (edit ? (handleSaveEdit(id)) : (handleAddServices()))}
                    height={40}
                    width={"100%"}
                    backgroundColor={'#101010'}
                    textColor={'white'}
                />
            </div>

        </div>
    );
};

function mapStateToProps({ Configuration }) {
    return {

    };
}


export default connect(mapStateToProps)(ConfigProductSpecFiled);
